import { useContext } from "react";
import { AuthContext } from "../../../../../context/AuthContext";
import { isFreelance } from "../../../../../utils/constants/accountType";
import { ProjectStatusBadge } from "../../../../../components/Status/ProjectStatus";
import { btn } from "../../../../../components/Button/buttonStyles";

const Card = ({ children }) => (
  <div className="bg-white border border-gray-100 shadow-sm rounded-lg p-5 space-y-3">
    {children}
  </div>
);

const Field = ({ label, value }) => {
  const isEmpty = value === null || value === undefined || value === "";
  return (
    <div className="flex items-start text-sm">
      <span className="w-40 shrink-0 text-xs font-medium text-gray-500 pt-px">
        {label}:
      </span>
      <span className="text-gray-900">{isEmpty ? "—" : value}</span>
    </div>
  );
};

const btnPrimary = btn("primary", "sm");
const btnWarning = btn("warning", "sm");

const ManagerStatusCard = ({ project }) => {
  const { user } = useContext(AuthContext);
  // Freelance accounts have no managers, so the card is status only.
  const freelance = isFreelance(user);

  const formatDateTime = (date) =>
    new Date(date).toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });

  return (
    <section>
      <div className="flex justify-between items-center mb-3">
        <h2 className="text-xl font-bold text-gray-900">
          {freelance ? "Status" : "Manager & Status"}
        </h2>
        <div className="flex items-center gap-2 text-sm">
          <button className={btnWarning}>Complete</button>
          <button className={btnPrimary}>Cancel</button>
        </div>
      </div>

      <Card>
        {!freelance && (
          <>
            <Field
              label="Primary Manager"
              value={
                project.primaryManager
                  ? `${project.primaryManager.first_name} ${project.primaryManager.last_name}`
                  : ""
              }
            />
            <Field
              label="Secondary Manager"
              value={
                project.secondaryManager
                  ? `${project.secondaryManager.first_name} ${project.secondaryManager.last_name}`
                  : ""
              }
            />
          </>
        )}
        <Field label="Status" value={<ProjectStatusBadge status={project.status} />} />
        <Field
          label="Deadline"
          value={
            project.deadline_at ? formatDateTime(project.deadline_at) : ""
          }
        />
      </Card>
    </section>
  );
};

export default ManagerStatusCard;
